import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'RoamingCountryFilter',
  pure: true 
})
export class CountryFilterPipe implements PipeTransform {
  transform(items: any[], search: string): any {
    if (!items || !search) {
        return items;
    }
    return items?.filter(item => item?.nameAr.indexOf(search?.toLowerCase()) > -1  ||  item?.countryName?.toLowerCase()?.indexOf(search?.toLowerCase()) > -1);
}

}
